import { render } from "./TodosComponent.vue?vue&type=template&id=8b7a3ecc"
import script from "./TodosComponent.vue?vue&type=script&lang=js"
export * from "./TodosComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__